import React, { Fragment } from "react";
import { Link, useLocation } from "react-router";
import { isActiveLink } from "@events-awards/utils/helpers";
import { AwardsMenu } from "@events-awards/utils/types";
import useScrollToCenter from "@hooks/useScrollToCenter";
import { cn } from "@util/helpers";

type EventsAwardsNavigationMenuProps = {
  /** The classname of the navigation menu */
  className?: string;
  /** The data of the navigation menu that will be used to displayed nav items. */
  menuData: AwardsMenu[];
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * Component to render Event and Awards navigation menu
 */
const EventsAwardsNavigationMenu = ({
  className,
  menuData,
}: EventsAwardsNavigationMenuProps): React.ReactElement => {
  const { pathname } = useLocation();
  const { containerRef, targetRef } = useScrollToCenter<
    HTMLUListElement,
    HTMLLIElement
  >(100);

  return (
    <div
      data-testid="events-awards-navigation-menu-component"
      className={cn("mt-6 border-t border-gray-175 py-6", className)}
    >
      <ul ref={containerRef} className="flex flex-row">
        {menuData.map(({ link, text, enabled }) => {
          const isActive = isActiveLink(link, pathname);

          if (!enabled) return <></>;

          return (
            <Fragment key={link}>
              <li
                ref={isActive ? targetRef : null}
                className="flex-shrink-0 px-3 text-center"
              >
                <Link
                  to={link}
                  reloadDocument
                  className={cn(
                    "font-poppins text-lg font-semibold text-gray-850 hover:text-black/70",
                    { "border-b-[2px] border-gray-850": isActive }
                  )}
                >
                  {text}
                </Link>
              </li>
            </Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default EventsAwardsNavigationMenu;
